import Brief from './brief';

export default Brief;